module.exports = __webpack_public_path__ + "static/media/sort.de74348a.svg";